import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.js';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { OnboardingLinkPage } from '@/__generated__/graphql.ts';
import {
  pointTitle,
  pointTitlesContainer,
  progressBar,
  progressBarContainer,
  progressLine,
  progressPoint,
} from '@/components/stripe-account/stripe-details-submitted-modal.css.ts';
import { StripeDetailsSubmitted } from '@/components/stripe-account/stripe-details-submitted.tsx';
import { useAppLoader } from '@/routes/_app/loader.ts';
import { deleteSearchParams } from '@/utils/handle-search-param.ts';

const StripeDetailsSubmittedModalComponent = ({
  redirectTo,
}: {
  redirectTo: OnboardingLinkPage;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const stripeDetailsSubmitted = searchParams.has('stripeDetailsSubmitted');
  const [open, onOpenChange] = useState(stripeDetailsSubmitted);

  useEffect(() => {
    if (stripeDetailsSubmitted)
      setSearchParams(
        deleteSearchParams(searchParams, ['stripeDetailsSubmitted']),
        {
          replace: true,
        },
      );
  }, [searchParams, setSearchParams, stripeDetailsSubmitted]);

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Create new stream</ModalTitle>
        </ModalHeader>

        {/* Simple static progress bar just to display state */}
        <div className={progressBarContainer}>
          <div className={progressBar}>
            <div className={progressLine} data-state={'filled'} />
            <div className={progressLine} data-state={'empty'} />
            <div className={progressPoint} data-state={'filled'}>
              &#10003;
            </div>
            <div className={progressPoint} data-state={'current'}>
              &#8226;
            </div>
            <div className={progressPoint} data-state={'empty'} />
          </div>
          <div className={pointTitlesContainer}>
            <span className={pointTitle}>Enter payout details</span>
            <span className={pointTitle}>Get verified by Stripe</span>
            <span className={pointTitle}>Create paid stream</span>
          </div>
        </div>

        <StripeDetailsSubmitted
          onClose={() => onOpenChange(false)}
          redirectTo={redirectTo}
        />
      </ModalContent>
    </ModalRoot>
  );
};

export const StripeDetailsSubmittedModal = ({
  redirectTo,
}: {
  redirectTo: OnboardingLinkPage;
}) => {
  const { authenticated } = useAppLoader();
  if (!authenticated) return null;

  return <StripeDetailsSubmittedModalComponent redirectTo={redirectTo} />;
};
